import $ from 'jquery';
const productForm = {
	init: function () {

		const checkPage = document.querySelector('.contact-form--product');
		if (checkPage == null) {
			return;
		}
		const selectProduct = document.querySelector('.select-product');
		const selectHelpTopic = document.querySelector('.select-help-topic');

		selectProduct.innerHTML = '';
		const optionElement = document.createElement('option');
		optionElement.text = '';
		optionElement.value = 'hide';
		selectProduct.appendChild(optionElement)

		if (selectProduct) {

			const hrefUrl = new URL(window.location.href);
			const hrefCampaignValue = hrefUrl.searchParams.get('utm_campaign');
			let hasCampaign = false;
			let campaignProduct = null;
			compensa_general.product_form.choose_product.forEach(function (item) {

				if (!item.api_campaign_value || (item.api_campaign_value == hrefCampaignValue)) {
					const optionElement = document.createElement('option');
					optionElement.text = item.title;
					optionElement.value = item.title;
					optionElement.classList.add(item.show_topic_for);
					optionElement.setAttribute('data-obligation-link', item.information_obligation);
					selectProduct.appendChild(optionElement)
				}

				if (item.api_campaign_value && hrefCampaignValue && item.api_campaign_value == hrefCampaignValue) {
					selectProduct.closest('.contact-form__row__item').style.display = 'none';
					hasCampaign = true;
					campaignProduct = item.title;
					selectProduct.value = item.title;

					window.hrefCampaignValueFound = hrefCampaignValue;
				}

			})
			if (hasCampaign) {
				const contactGreenBox = document.querySelector(`.contact-green-box-block`);
				const contactGreenBoxContent = contactGreenBox ? contactGreenBox.querySelector('.container') : null;
				let productForm = document.querySelector('.js-product-form-modal .wpcf7');
				if (contactGreenBox && contactGreenBoxContent && productForm) {
					productForm.querySelector('label[for="purchase"]').click();

					productForm.querySelector(".contact-form__title").innerHTML = "\x3cbr/\x3e\x3ch1\x3eZostaw kontakt - oddzwonimy z ofert\u0105\x3c/h1\x3e";
					productForm.querySelector(".content-switcher__navigation").style.display = "none";

					productForm.querySelector(".content-switcher__content").style.cssText = "max-width: 600px; margin-left: auto; margin-right: auto;";
					productForm = productForm.closest(".contact-form-modal__inner .container")

					contactGreenBoxContent.style.display = 'none';
					contactGreenBox.append(productForm);

					const switches = productForm.querySelectorAll(`.form-checkbox-dynamic[data-switcher]`)
					switches.forEach(function (switchItem) {
						let switchItemData = switchItem.getAttribute('data-switcher');
						switchItemData = switchItemData.split(',').map(function (item) {
							return item.trim();
						})
						if (switchItemData.includes(campaignProduct)) {
							switchItem.style.display = 'block';
						}
					})

					setTimeout(() => {
						productForm.querySelector('.select-options [value="' + campaignProduct + '"] span').click()
					}, 5000);
				}
			}
		}

		if (selectHelpTopic) {
			compensa_general.product_form.topics.forEach(function (item) {
				const aElement = document.createElement('a');
				const spanElement = document.createElement('span');
				spanElement.innerText = item.link.title;
				aElement.append(spanElement);
				aElement.href = item.link.url;
				aElement.target = '_blank';
				selectHelpTopic.appendChild(aElement)
			})
		}

		if (selectProduct) {
			const selectProductElement = selectProduct.parentElement.querySelector('select');
			$(selectProductElement).on('change', function (event) {
				const getConsentLink = event.target.selectedOptions[0].getAttribute('data-obligation-link');

				productForm.acceptanceLink(getConsentLink)
			})
		}

		const getButtons = document.querySelectorAll('.js-switcher-by-id-navigation-item');

		if (getButtons.length && selectProduct) {
			getButtons.forEach(button => {
				button.addEventListener('click', function () {
					productForm.resetSelect();
				})
			})
		}

	},
	acceptanceLink: function (linkSelector) {
		const acceptance = document.querySelector('.contact-form__information-obligation');

		if (!acceptance) {
			return;
		}
		if (linkSelector) {
			acceptance.setAttribute('href', linkSelector);
		}
	},
	acceptanceSwitcher: function (switcherSelector) {
		const acceptanceElements = document.querySelectorAll('.form-checkbox-dynamic');
		if (acceptanceElements.length === 0) {
			return;
		}
		acceptanceElements.forEach(function (el) {
			const searchFor = el.dataset.switcher;
			const inputElement = el.querySelector('input');
			if (!searchFor.includes(switcherSelector)) {
				$(el).removeClass('active');
				inputElement.checked = false;
			} else {
				el.classList.add('active')
				$(el).siblings().removeClass('active')
			}
		})
	},
	resetSelect() {
		const productForm = document.querySelector('.js-product-form-modal');

		if (!productForm) {
			return;
		}

		const selectors = productForm.querySelectorAll('.custom-select');

		selectors.forEach(selector => {
			selector.value = 'hide'
			selector.parentNode.querySelector('.select-styled').innerText = ''
			selector.parentNode.querySelector('.select-styled').classList.remove('selected')

			var changeEvent = new Event('change');
			selector.dispatchEvent(changeEvent);
		})

	},
	showHideField: function (field, selectedItem, acfField = 'show_zip_code') {
		const getField = document.querySelector(`[data-name="${field}"]`);
		if (!getField) {
			return;
		}
		$(getField).hide();
		const arrayWithKeys = this.getArrayWithKeysForSpecificField(compensa_general.product_form.choose_product, 'title', acfField);
		if (arrayWithKeys[`${selectedItem}`] === true) {
			$(getField).show();
		} else {
			$(getField).hide();
		}

	},
	getArrayWithKeysForSpecificField: function (array, key, field) {
		const newArray = {};
		array.forEach(function (item) {
			newArray[item[key]] = item[field]
		})
		return newArray;
	},

	activeProductTab: function () {
		const isProductPageTemplate = document.querySelector('.page-template-page-product-form');
		if (!isProductPageTemplate) {
			return;
		}

		const isProductForYouTab = isProductPageTemplate.querySelector('[data-product-type="for_you"]');

		if (!isProductForYouTab) {
			return;
		}

		isProductForYouTab.click();
	}
}

export default productForm;
